export var AccountStatusReason;
(function (AccountStatusReason) {
    AccountStatusReason["ACCOUNT_STATUS_REASON_UNSPECIFIED"] = "ACCOUNT_STATUS_REASON_UNSPECIFIED";
    AccountStatusReason["ACCOUNT_STATUS_REASON_MISSING_INTERNAL_RESOURCE_GROUP"] = "MISSING_INTERNAL_RESOURCE_GROUP";
})(AccountStatusReason || (AccountStatusReason = {}));
